import { TASK_CONST } from '@/constant';
import type { Project, WorkProgress } from '@/type';

export const getProjectState = (project: Project): WorkProgress => {
  const filteredTask = project.task?.filter(
    task => task.state !== TASK_CONST.TASK_WORKSTATE.FAIL,
  );
  if (
    filteredTask?.length &&
    filteredTask.every(
      task => task.state === TASK_CONST.TASK_WORKSTATE.COMPLETED,
    )
  )
    return 'Completed';

  if (
    filteredTask?.some(
      task => task.state === TASK_CONST.TASK_WORKSTATE.PROGRESS,
    )
  )
    return 'In progress';

  return 'Not started';
};
